import { getSegment } from "./helpers";

/** @typedef {{ type: string, state: string, text: string, payload: object, [key: string]: string|object}} EventData1Mind */

export function attach1MindEventListener() {
  window.removeEventListener("message", handle1MindEvent);
  window.addEventListener("message", handle1MindEvent);
}

/**
 *
 * @param {MessageEvent} event
 * @returns void
 */
function handle1MindEvent(event) {
  // Verify the event origin is 1Mind
  let hostname;
  try {
    hostname = new URL(event.origin).hostname;
  } catch (e) {
    // Origin is not a valid URL -> ignore the event
    return;
  }
  if (hostname.endsWith(".1mind.com") === false) return;
  if (!event.data || !event.data.type) return;

  track1MindEvent(event.data);
}

/**
 *
 * @param {EventData1Mind} eventData
 */
function track1MindEvent(eventData) {
  const eventName = eventData.type;

  if (!eventName.startsWith("1mind_")) return;

  const eventProperties = {
    state: eventData.state,
    text: eventData.text,
    ...eventData.payload,
  };

  getSegment("track")(eventName, eventProperties);
}
